module.exports = __webpack_public_path__ + "img/av004.784a83b9.png";